import { BaseClient } from 'src/common-services/clients/base-client'
import { Polygon } from 'src/common-services/types/geojson-types'
import { ZoneDetailArea, ZoneDetailResponse } from 'src/common-services/types/zone-types'

export class ZoneClient extends BaseClient {
  getDetailByLocation(lat: number, lng: number): Promise<ZoneDetailResponse> {
    return this.post('/zone/detail/by-location', { lat, lng })
  }

  getAreaByLocation(lat: number, lng: number): Promise<ZoneDetailArea> {
    return this.post('/zone/area/by-location', { lat, lng })
  }

  getAreaByPolygon(polygon: Polygon): Promise<ZoneDetailArea> {
    return this.post('/zone/area/by-polygon', { polygon })
  }
}
